import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  fieldObjectDocumentos,
  headersDocumentos,
  valoresExibidosDocumentosSisAF,
} from './auxiliarDocumentos';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import Select from '../../../../components/InputNew/Select';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import BolinhaTabelaStatus from '../../../../components/bolinhaTabelaStatus';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useTipoExtensaoDocumento } from '../../../../services/enum/useExtensaoDocumento';
import { useStatusDocumento } from '../../../../services/enum/useStatusDoc';
import { useTipoDocumento } from '../../../../services/enum/useTipoDocumento';
import { getAllDocumentosGestaoSisAf } from '../../../../services/gestaoSisAF/documentosSisAfService';
import { ENTITY } from '../../../../utils/entityNames';
import {
  ExportToExcel,
  formataNomeMeioSiglas,
  formatDate,
  formatDateSimp,
} from '../../../../utils/functions';
import { getSubAbas } from '../subabas';

const MaisOpcoesDocumentos: React.FC = () => {
  //Dados do usuário
  const user = getUser();
  const userID = user.sub;
  const entity = ENTITY.ENTITY_DocumentosSisAF;
  const tipoDocumentoGestaoSisAF = useTipoDocumento();
  const tipoExtensaoDocumento = useTipoExtensaoDocumento();
  const statusDoc = useStatusDocumento();
  const navigate = useNavigate();

  //Dados do componente
  const [formFiltros, setFormFiltros] = useState({
    statusDoc: 0,
    tipoDocumentoGestaoSisAF: 0,
    responsavelDocumento: 0,
    titulo: '',
  });
  const [data, setData] = useState<any[]>([]);

  // Buscar dados
  const fetchData = async () => {
    try {
      const documentosData = await getAllDocumentosGestaoSisAf();
      setData(documentosData);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  //Dados da tabela
  const tableData = data
    .filter((item: any) => {
      return (
        (formFiltros.tipoDocumentoGestaoSisAF === 0 ||
          String(item.tipoDocumento) ===
            String(formFiltros.tipoDocumentoGestaoSisAF)) &&
        (formFiltros.statusDoc === 0 ||
          item.statusDoc === formFiltros.statusDoc) &&
        (formFiltros.titulo === '' ||
          item.titulo.toLowerCase().includes(formFiltros.titulo.toLowerCase()))
      );
    })
    .map((item) => {
      // Definindo o status para 'S', 'A' ou 'N'
      const status =
        item.statusDoc === 2 ? 'S' : item.statusDoc === 1 ? 'A' : 'N';

      return {
        id: item.id,
        statusDoc: (
          <>
            <BolinhaTabelaStatus status={status} />
          </>
        ),
        localizador: item.localizador,
        dataCriacao: formatDateSimp(item.dataCriacao),
        tipoDocumento:
          tipoDocumentoGestaoSisAF[item.tipoDocumento]?.label || '',
        extensaoDocumento:
          tipoExtensaoDocumento[item.extensaoDocumento]?.label || '',
        titulo: item.titulo,
      };
    });

  //Dados do Offcanvas
  const offCanvasData = data.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    separadorLog: '',
    statusDoc: statusDoc[item.statusDoc].label,
    localizador: item.localizador,
    dataCriacao: formatDateSimp(item.dataCriacao),
    extensaoDocumento: tipoExtensaoDocumento[item.extensaoDocumento].label,
    tipoDocumento: tipoDocumentoGestaoSisAF[item.tipoDocumento].label,
    responsavelDocumento: item.responsavelDocumento,
    titulo: item.titulo,
    resumo: item.resumo,
    link: (
      <a href={item.link} target="_blank" rel="noopener noreferrer">
        {item.link}
      </a>
    ),
    separadorObservacoes: '',
    observacoes: item.observacoes,
  }));

  interface DocumentoSisAF {
    id: number;
    dataRegistro: string;
    usuarioRegistro: {
      nomeCompleto: string;
    };
    dataUltimaAtualizacao: string;
    usuarioAtualizacao: {
      nomeCompleto: string;
    };
    dataUltimaVisualizacao: string;
    usuarioUltimaVisualizacao: {
      nomeCompleto: string;
    };
    nEdicoes: number;
    nVisualizacoes: number;
    nVisualizadores: number;

    //Específicos
    localizador: string;
    tipoDocumento: number;
    extensaoDocumento: number;
    statusDoc: number;
    responsavelDocumento: string;
    titulo: string;
    resumo: string;
    link: string;

    //Observações
    observacoes: string;
  }

  const prepareDataForExport = (data: DocumentoSisAF[]) => {
    return data.map((item) => {
      const status =
        item.statusDoc === 2 ? 'S' : item.statusDoc === 1 ? 'A' : 'N';

      return {
        id: item.id,
        localizador: item.localizador,

        //Logs
        dataRegistro: item.dataRegistro,
        usuarioRegistro: item.usuarioRegistro.nomeCompleto,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto,
        dataUltimaVisualizacao: item.dataUltimaVisualizacao,
        usuarioUltimaVisualizacao: item.usuarioUltimaVisualizacao.nomeCompleto,
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        nVisualizadores: item.nVisualizadores,

        //Específicos
        tipoDocumento:
          tipoDocumentoGestaoSisAF[item.tipoDocumento]?.label || '',
        extensaoDocumento:
          tipoExtensaoDocumento[item.extensaoDocumento]?.label || '',
        statusDoc: statusDoc[item.statusDoc]?.label || status,
        responsavelDocumento: item.responsavelDocumento,
        titulo: item.titulo,
        resumo: item.resumo,
        link: item.link,

        //Observações
        observacoes: item.observacoes,
      };
    });
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    if (name === 'statusDoc') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        statusDoc: newValue,
      });
    } else {
      setFormFiltros((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      statusDoc: 0,
      tipoDocumentoGestaoSisAF: 0,
      responsavelDocumento: 0,
      titulo: '',
    });
  };

  const handleClickInserir = () => {
    navigate('ficha/dadosgerais');
  };

  return (
    <>
      <BarraSubAbas subAbas={getSubAbas()} />

      <ContainerConteudo>
        <BoxConteudo boxTitulo="Filtros" fechado>
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="10%">
              <Select
                name="statusDoc"
                value={formFiltros.statusDoc}
                options={statusDoc}
                onChange={handleChange}
                label="Status"
              />
            </CustomCol>
            <CustomCol width="20%">
              <Select
                name="tipoDocumentoGestaoSisAF"
                value={formFiltros.tipoDocumentoGestaoSisAF}
                options={tipoDocumentoGestaoSisAF}
                onChange={handleChange}
                label="Tipo de Documento"
              />
            </CustomCol>
            <CustomCol>
              <Input
                id="titulo"
                name="titulo"
                value={formFiltros.titulo}
                label="Título"
                onChange={handleChange}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <Tabela
          headers={headersDocumentos}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidosDocumentosSisAF}
          tituloCanvas="DOCUMENTO SISAF"
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          onClickDownload={() =>
            ExportToExcel(
              prepareDataForExport(data),
              valoresExibidosDocumentosSisAF,
              fieldObjectDocumentos,
              'sisaf_documentos.xlsx',
              userID,
              'DAF', // Nome da interface
              entity, // Nome da entidade
            )
          }
          inserir
          onClickInserir={handleClickInserir}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default MaisOpcoesDocumentos;
